import type { OfferPhase } from "@/lib/offer-calc";

/**
 * VIB-1054: avgjør om en default-mal skal legges til på et nytt tilbud.
 * Reise-defaultlinjer droppes når reise faktureres separat (medgått), siden
 * reisetid da håndteres som medgått på prosjektet.
 */
export function includeDefaultLine(
  template: { phase: OfferPhase | string },
  billsTravelPerMedgatt: boolean,
): boolean {
  return !billsTravelPerMedgatt || template.phase !== "reise";
}

/**
 * Beregner timer for tilbudsskriving-credit gitt forventet BF.
 * Default 2t per 100 000, oppjustert til hele time.
 */
export function computeOfferWritingHours(
  bfAmount: number,
  hoursPer100k: number = 2,
): number {
  if (!bfAmount || bfAmount <= 0) return 0;
  return Math.ceil((bfAmount / 100000) * hoursPer100k);
}
